import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('userPin', 'userPins');

const customActions = {
  async LOAD_usernames({ rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('userPins')
      .query({ $select: 'username', $orderby: 'username' });
    return data;
  },
};

export default { ...actions, ...customActions };
